import { Locale } from 'antd/es/locale';

const localeValues: Locale = {
  locale: 'et',
  Table: {
    filterReset: "Lähtesta"
  }
}

export default localeValues;